import {CLEAR_ERROR_PANEL, GET_DATA_FAILED, GET_DATA_SUCCESS, GET_QUOTAS} from '../actions/types';

const initialState = {
    error: false,
    errorMessage: null,
    quotas: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_DATA_SUCCESS:
            return {
                ...state,
                error: false,
                errorMessage: null
            };
        case GET_DATA_FAILED:
            return {
                ...state,
                error: true,
                errorMessage: action.payload
            };
        case CLEAR_ERROR_PANEL:
            return {
                ...state,
                Success: null,
                message: action.payload
            };
        case GET_QUOTAS:
            return {
                ...state,
                quotas: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/fetchReducer.js